module.exports = __webpack_public_path__ + "media/images/service/c_12-69dfac7f17fc3ba1358f8d31ee3d6a21.png";